"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var GlobalStateContext_1 = require("../../utils/GlobalStateContext");
var InputFormControl_1 = __importDefault(require("../../components/formControls/InputFormControl"));
var InputArticleIdContentTab = function () {
    // global state context things
    var context = (0, react_1.useContext)(GlobalStateContext_1.GlobalStateContext);
    var state = context.state, setState = context.setState;
    var setSelectedArticle = function (newSelectedArticle) { return setState(function (prevState) { return (__assign(__assign({}, prevState), { articleId: newSelectedArticle })); }); };
    var handleSubmit = function (event) {
        event.preventDefault();
        var input = event.currentTarget.elements.namedItem('articleIdInput');
        if (input) {
            setSelectedArticle(input.value);
        }
    };
    var _a = (0, react_1.useState)(''), submitText = _a[0], setSubmitText = _a[1];
    (0, react_1.useEffect)(function () {
        setSubmitText(window.bes.spareparts.submittext);
    }, []);
    var buttonStyles = {
        position: "relative",
        top: "28px"
    };
    return (react_1.default.createElement("div", { className: "spr-input-article-id-tab container" },
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-1" }),
                react_1.default.createElement("div", { className: "col-7" },
                    react_1.default.createElement(InputFormControl_1.default, { id: "articleIdInput", initialValue: state.articleId })),
                react_1.default.createElement("div", { className: "col-4" },
                    react_1.default.createElement("button", { type: "submit", className: "btn btn-primary", style: buttonStyles }, submitText))))));
};
InputArticleIdContentTab.displayName = "Input ArticleId Content Tab";
exports.default = InputArticleIdContentTab;
